import { render, staticRenderFns } from "./AgriTrace.vue?vue&type=template&id=665d002a&scoped=true"
import script from "./AgriTrace.vue?vue&type=script&lang=js"
export * from "./AgriTrace.vue?vue&type=script&lang=js"
import style0 from "./AgriTrace.vue?vue&type=style&index=0&id=665d002a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d002a",
  null
  
)

export default component.exports